import script from "./ErrorPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ErrorPage.vue?vue&type=script&setup=true&lang=js"

import "./ErrorPage.vue?vue&type=style&index=0&id=626f4451&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-626f4451"]])

export default __exports__